<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i class="bi bi-receipt"></i>
        Comprobantes de prueba
      </h6>
    </div>
    <div class="form-card__body">
    <div class="form-card__field">
      <label class="form-card__label">Factura de prueba:</label>
      <div class="input-group">
        <input disabled id="template_test" name="template_test" v-model="bo_configs.template_test" placeholder="Template de prueba" type="text" maxlength="36" class="form-control">
        <div class="input-group-append">
          <button type="button" class="form-card__btn">Vista previa</button>
        </div>
      </div>
    </div>

    <div class="form-card__field">
      <label class="form-card__label">Factura electrónica:</label>
      <div class="input-group">
        <input disabled id="template_digital" name="template_digital" v-model="bo_configs.template_digital" placeholder="Template electrónico" type="text" maxlength="36" class="form-control">
        <div class="input-group-append">
          <button type="button" class="form-card__btn">Vista previa</button>
        </div>
      </div>
    </div>

    <div class="form-card__field">
      <label class="form-card__label">Factura fiscal:</label>
      <div class="input-group">
        <input disabled id="template_fiscal" name="template_fiscal" v-model="bo_configs.template_fiscal" placeholder="Template fiscal" type="text" maxlength="36" class="form-control">
        <div class="input-group-append">
          <button type="button" class="form-card__btn">Vista previa</button>
        </div>
      </div>
    </div>

    <div class="form-card__field">
      <label class="form-card__label">Presupuesto:</label>
      <div class="input-group">
        <input disabled id="template_budget" name="template_budget" v-model="bo_configs.template_budget" placeholder="Template presupuesto" type="text" maxlength="36" class="form-control">
        <div class="input-group-append">
          <button type="button" class="form-card__btn">Vista previa</button>
        </div>
      </div>
    </div>

    <div class="form-card__field">
      <label class="form-card__label">Recibo:</label>
      <div class="input-group">
        <input disabled id="template_receipt" name="template_receipt" v-model="bo_configs.template_receipt" placeholder="Template recibo" type="text" maxlength="36" class="form-control">
        <div class="input-group-append">
          <button type="button" class="form-card__btn">Vista previa</button>
        </div>
      </div>
    </div>

    <div class="form-card__field">
      <label class="form-card__label">Remito</label>
      <div class="input-group">
        <input disabled id="template_shipping_note" name="template_shipping_note" v-model="bo_configs.template_shipping_note" placeholder="Template remito" type="text" maxlength="36" class="form-control">
        <div class="input-group-append">
          <button type="button" class="form-card__btn">Vista previa</button>
        </div>
      </div>
    </div>

    <div class="form-card__field">
      <label class="form-card__label">Nota de Pedido</label>
      <div class="input-group">
        <input disabled id="template_order_note" name="template_order_note" v-model="bo_configs.template_order_note" placeholder="Template nota de pedido" type="text" maxlength="36" class="form-control">
        <div class="input-group-append">
          <button type="button" class="form-card__btn">Vista previa</button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['bo_configs'],
  data: function() {
    return {
    }
  },
  mounted: function() {
  },
}
</script>
